import React from "react";
import Loader from "../components/common/loader/loader";
import BannerNotification from "../components/common/banner/bannerNotification";
import Checkbox from "../components/common/checkbox/checkbox";
import i18n from "../../localization/i18n";
import * as rk from "../../localization/resourceKeys";
import { StepLayout } from "../components/common/steplayout/StepLayout";

const eSignDisclosureVW = "/assets/E-SIGN General - VWC.pdf";
const OnlineAccessLink = (() => {
  return process.env.REACT_APP_AWS_ENV === "prod"
    ? `https://content.ownerportal.vwcredit.io/tnc/vw/OnlineAccess`
    : `https://content.${process.env.REACT_APP_AWS_ENV}.ownerportal.vwcredit.io/tnc/vw/OnlineAccess`;
})();

interface MyVWPaperlessConsentProps {
  email: string;
  agreeConsent: boolean;
  loading: boolean;
  error: string | null;
  verifyErrorBanner: { title?: string; message: string } | null;
  onAgreeChange: (checked: boolean) => void;
  onContinue: () => void;
  onCancel: () => void;
  continueDisabled: boolean;
  title?: string;
  cancelTestId?: string;
  continueTestId?: string;
  checkboxTestId?: string;
  isRegistrationFlow?: boolean;
}

const MyVWPaperlessConsent: React.FC<MyVWPaperlessConsentProps> = ({
  email,
  agreeConsent,
  loading,
  error,
  verifyErrorBanner,
  onAgreeChange,
  onContinue,
  onCancel,
  continueDisabled,
  title,
  cancelTestId,
  continueTestId,
  checkboxTestId,
  isRegistrationFlow,
}) => {

  const consentText = (
    <>
      {i18n.t(rk.TEXT_CONSENT_PAPERLESS_AGREE)}
      <a
        href={
          eSignDisclosureVW
        }
        target="_blank"
        rel="noopener noreferrer"
      >
        {i18n.t(rk.LINK_ESIGN_CONSENT_AGREE)}
      </a>
      {i18n.t(rk.TEXT_CONSENT_PAPERLESS_AGREE_1)}
      <a href={OnlineAccessLink} target="_blank" rel="noopener noreferrer">
        {i18n.t(rk.LINK_TERMS_CONSENT_AGREE)}
      </a>
      {"."}
    </>
  );
  return (
    <StepLayout
      title={<h3 className='u-mb-small'>{title ?? i18n.t(rk.TITLE_MYVW_REGISTER_FORM)}</h3>}
      primaryAction={{
        label: i18n.t(rk.BUTTON_CANCEL),
        onClick: onCancel,
        testId: cancelTestId,
      }}
      secondaryAction={{
        label: i18n.t(rk.BUTTON_CONTINUE),
        onClick: onContinue,
        disabled: continueDisabled,
        testId: continueTestId,
      }}
    >
      {isRegistrationFlow && <h4 className="u-text-subtitle u-mb-xsmall">{i18n.t(rk.LABEL_MYVW_PAPERLESS_ENROLL)}</h4>}
      {loading && <Loader isLoading />}
      {verifyErrorBanner && (
        <div className="u-mb">
          <BannerNotification notificationStyle="error" title={verifyErrorBanner.title}>
            {verifyErrorBanner.message}
          </BannerNotification>
        </div>
      )}
      {error && <p className="c-error-message u-mt">{error}</p>}
      <p className="u-mt">
        {i18n.t(rk.TEXT_MYVW_PAPERLESS_ENROLL)}
      </p>
      <h5>{email}</h5>
      <p>
        {i18n.t(rk.TEXT_MYVW_PAPERLESS_ENROLL_DESC)}
      </p>
      <p>
        {i18n.t(rk.TEXT_MYVW_PAPERLESS_ENROLL_DOCUMENTS)}
      </p>
      <div className="u-mt u-mb">
        <Checkbox
          id="agreeConsent"
          label={consentText}
          checked={agreeConsent}
          onChange={(e: any) => onAgreeChange(e.target.checked)}
          testid={checkboxTestId}
        />
      </div>
      <p>
        <b>{i18n.t(rk.LABEL_MYVW_PAPERLESS_ENROLL_NOTE)} </b>
        {i18n.t(rk.TEXT_MYVW_PAPERLESS_ENROLL_NOTE_DESC)}
      </p>
    </StepLayout>
  );
};

export default MyVWPaperlessConsent;